(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-rich-text"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Constants ── */
  var GSAP_CDN    = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  var ST_CDN      = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
  var DIM_OPACITY = 0.12;   /* starting opacity of each word */
  var SCRUB       = 1.4;    /* scroll scrub smoothing */
  var START_PAD   = 'top 85%'; /* when animation starts */
  var END_PAD     = 'bottom 15%'; /* when animation ends */

  /* ── Word splitter ── */
  function splitWords(el) {
    var raw   = el.textContent.trim();
    var words = raw.split(/\s+/);
    el.innerHTML = words
      .map(function (w) {
        return '<span class="art__word">' + escHtml(w) + '</span>';
      })
      .join('');
    return el.querySelectorAll('.art__word');
  }

  function escHtml(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── GSAP animation per paragraph ── */
  function animatePara(el) {
    var words = splitWords(el);
    if (!words.length) return;

    /* Set all words to dim opacity to start */
    gsap.set(words, { opacity: DIM_OPACITY });

    gsap.to(words, {
      opacity: 1,
      ease: 'none',
      stagger: {
        each: 0.04,
        from: 'start'
      },
      scrollTrigger: {
        trigger: el,
        start: START_PAD,
        end: END_PAD,
        scrub: SCRUB,
        /* markers: true  ← uncomment to debug */
      }
    });
  }

  /* ── Boot: init one section ── */
  function initSection(root) {
    var paras = root.querySelectorAll('[data-art-animate]');
    if (!paras.length) return;
    paras.forEach(function (p) { animatePara(p); });
  }

  /* ── Script loader (deduplicates if GSAP already present) ── */
  function loadScript(src, cb) {
    if (document.querySelector('script[src="' + src + '"]')) {
      /* already loading / loaded — wait for it */
      var existing = document.querySelector('script[src="' + src + '"]');
      if (window.gsap && window.ScrollTrigger) { cb(); return; }
      existing.addEventListener('load', cb);
      return;
    }
    var s = document.createElement('script');
    s.src = src;
    s.onload = cb;
    document.head.appendChild(s);
  }

  /* ── Main entry ── */
  function boot(sectionRoot) {
    /* If GSAP + ST already registered, just run */
    if (window.gsap && window.ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      initSection(sectionRoot);
      return;
    }

    /* Load GSAP, then ScrollTrigger, then init */
    loadScript(GSAP_CDN, function () {
      loadScript(ST_CDN, function () {
        gsap.registerPlugin(ScrollTrigger);
        initSection(sectionRoot);
      });
    });
  }

  /* ── Find all animated rich text sections and boot each ── */
  function bootAll(root) {
    root = root || document;
    root.querySelectorAll('[data-art-section]').forEach(function (sec) {
      boot(sec);
    });
  }

  /* On initial page load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(); });
  } else {
    bootAll();
  }

  /* Shopify editor: re-run when a section is added/reloaded */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('[data-art-section]')) {
      boot(e.target.querySelector('[data-art-section]'));
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cover-reveal"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var inEditor = !!(window.Shopify && window.Shopify.designMode);

  /* ── Editor: flatten all panels so every block is editable ── */
  function initEditorMode(wrapperEl) {
    var stickyEl = wrapperEl.querySelector('.cv-sticky');
    var panels   = wrapperEl.querySelectorAll('[data-cv-panel]');
    wrapperEl.style.height = 'auto';
    if (stickyEl) {
      stickyEl.style.position = 'static';
      stickyEl.style.height   = 'auto';
      stickyEl.style.overflow = 'visible';
    }
    Array.prototype.forEach.call(panels, function (panel) {
      panel.style.position  = 'static';
      panel.style.height    = '100vh';
      panel.style.minHeight = '100vh';
      panel.style.transform = 'none';
    });
  }

  /* ── Live: sticky wrapper + scroll-driven panel reveal ───── */
  function initCoverReveal(wrapperEl) {
    if (window.innerWidth <= 768) return;

    var panels = Array.prototype.slice.call(wrapperEl.querySelectorAll('[data-cv-panel]'));
    if (panels.length < 2) return;

    var speed = parseInt(wrapperEl.dataset.cvSpeed, 10) || 200;
    var hold  = parseInt(wrapperEl.dataset.cvHold,  10) || 80;
    var total = hold + speed * (panels.length - 1) + hold;

    /* Give the wrapper the extra scroll space */
    wrapperEl.style.height = (100 + total) + 'vh';

    /* Force non-first panels off-screen (belt + braces over CSS class) */
    for (var j = 1; j < panels.length; j++) {
      panels[j].style.transform = 'translateY(100%)';
    }

    /* Return target yPercent for panel[i] given overall progress 0→1 */
    function targetY(i, progress) {
      var holdFrac = hold  / total;
      var moveFrac = 1 - 2 * holdFrac;
      var n        = panels.length - 1;
      var start    = holdFrac + (i - 1) * (moveFrac / n);
      var end      = start    + (moveFrac / n);
      var p        = Math.max(0, Math.min(1, (progress - start) / (end - start)));
      return 100 * (1 - p);
    }

    /* Lerped current positions */
    var cur  = panels.map(function (_, i) { return i === 0 ? 0 : 100; });
    var tgt  = panels.map(function (_, i) { return i === 0 ? 0 : 100; });
    var rafId = null;

    function readProgress() {
      var rect       = wrapperEl.getBoundingClientRect();
      var scrolled   = -rect.top;
      var scrollable = wrapperEl.offsetHeight - window.innerHeight;
      if (scrollable <= 0) return 0;
      return Math.max(0, Math.min(1, scrolled / scrollable));
    }

    function renderFrame() {
      rafId = null;
      var done = true;
      for (var i = 1; i < panels.length; i++) {
        cur[i] += (tgt[i] - cur[i]) * 0.1;
        if (Math.abs(tgt[i] - cur[i]) > 0.02) done = false;
        panels[i].style.transform = 'translateY(' + cur[i].toFixed(2) + '%)';
      }
      if (!done) rafId = requestAnimationFrame(renderFrame);
    }

    function onScroll() {
      var progress = readProgress();
      for (var i = 1; i < panels.length; i++) {
        tgt[i] = targetY(i, progress);
      }
      if (!rafId) rafId = requestAnimationFrame(renderFrame);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      wrapperEl.style.height = (100 + total) + 'vh';
      onScroll();
    });

    onScroll();
  }

  /* ── Cinematic panel reveals (cvpp--cine) ─────────────────── */
  function wireCine() {
    var bands = document.querySelectorAll('[data-cv-cine]');
    if (!bands.length) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    Array.prototype.forEach.call(bands, function (b) {
      if (b.classList.contains('cvpp--js')) return;
      /* synchronously reveal if already on screen so the CSS safety-net
         handoff never flashes blank */
      var r = b.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) b.classList.add('cvpp--in');
      b.classList.add('cvpp--js');
    });
    if (!('IntersectionObserver' in window) || reduced || inEditor) {
      Array.prototype.forEach.call(bands, function (b) { b.classList.add('cvpp--in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('cvpp--in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.25 });
    Array.prototype.forEach.call(bands, function (b) {
      if (!b.classList.contains('cvpp--in')) io.observe(b);
    });
  }

  /* ── Bootstrap ───────────────────────────────────────────── */
  function init() {
    wireCine();
    var wrappers = document.querySelectorAll('[data-cover-reveal]');
    if (!wrappers.length) return;
    if (inEditor) {
      Array.prototype.forEach.call(wrappers, initEditorMode);
      return;
    }
    Array.prototype.forEach.call(wrappers, initCoverReveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── Shopify editor events ───────────────────────────────── */
  document.addEventListener('shopify:block:select', function (e) {
    if (!inEditor) return;
    var panel = e.target;
    if (panel && panel.hasAttribute('data-cv-panel')) {
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-cover-reveal]');
    if (!el) return;
    wireCine();
    if (inEditor) { initEditorMode(el); return; }
    initCoverReveal(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {

  function initHero(heroEl) {
    var parallax = heroEl.dataset.parallax === 'true';
    var bgMedia  = heroEl.querySelector('.hero__image, .hero__video');
    var videoEl  = heroEl.querySelector('[data-hero-video]');

    /* ── Parallax ─────────────────────────────────────────────────────── */
    if (parallax && bgMedia) {
      var pending = false;
      window.addEventListener('scroll', function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          var rect = heroEl.getBoundingClientRect();
          var wh   = window.innerHeight;
          if (rect.bottom < 0 || rect.top > wh) return;
          var p = -rect.top / (rect.height + wh);
          bgMedia.style.transform = 'scale(1.15) translateY(' + (p * 25).toFixed(2) + '%)';
        });
      }, { passive: true });
    }

    /* ── Play while visible, pause when scrolled away ─────────────────── */
    if (videoEl) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { videoEl.play().catch(function () {}); }
          else { videoEl.pause(); }
        });
      }, { threshold: 0.1 });
      io.observe(heroEl);
    }
  }

  /* ── Cookie banner ────────────────────────────────────────────────────── */
  function initCookies() {
    document.querySelectorAll('[data-cookie-banner]').forEach(function (banner) {
      document.body.appendChild(banner);
      var key = banner.dataset.cookieKey;
      if (!key || localStorage.getItem(key)) return;
      setTimeout(function () { banner.classList.add('is-visible'); }, 600);
      function dismiss(val) {
        localStorage.setItem(key, val);
        banner.classList.remove('is-visible');
      }
      var accept  = banner.querySelector('[data-cookie-accept]');
      var decline = banner.querySelector('[data-cookie-decline]');
      if (accept)  accept.addEventListener('click',  function () { dismiss('accepted'); });
      if (decline) decline.addEventListener('click', function () { dismiss('declined'); });
    });
  }

  function init() {
    document.querySelectorAll('[data-section="hero"]').forEach(initHero);
    initCookies();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["horizontal-scroll"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var GSAP_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  var ST_CDN   = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';

  // ── Panel content selectors animated on panel change (desktop) ───────────────
  var CONTENT_SEL = [
    '.hs-panel__eyebrow', '.hs-shared__eyebrow',
    '.hs-panel__heading', '.hs-shared__heading',
    '.hs-panel__text',    '.hs-shared__text',
    '.hs-panel__btn',     '.hs-shared__btn',
    '.hs-scatter__center'
  ].join(',');

  // ── Mobile selector: individual elements, not the scatter wrapper ─────────────
  var CONTENT_SEL_MOBILE = [
    '.hs-panel__eyebrow', '.hs-shared__eyebrow',
    '.hs-panel__heading', '.hs-shared__heading',
    '.hs-panel__text',    '.hs-shared__text',
    '.hs-panel__btn',     '.hs-shared__btn'
  ].join(',');

  var lastPanelIdx = -1;

  function revealPanelContent(panelEl, direction) {
    if (panelEl.querySelector('.hs-iwt')) return; // image+text panels: no reveal
    var items = panelEl.querySelectorAll(CONTENT_SEL);
    if (!items.length) return;
    /* Hide all items first, then stagger-reveal them */
    gsap.set(items, { opacity: 0, y: direction === 'back' ? -28 : 36 });
    gsap.to(items, {
      opacity:  1,
      y:        0,
      duration: 0.66,
      ease:     'power3.out',
      stagger:  0.1,
      delay:    0.08
    });
  }

  function hidePanelContent(panelEl, direction) {
    if (panelEl.querySelector('.hs-iwt')) return; // image+text panels: no reveal
    var items = panelEl.querySelectorAll(CONTENT_SEL);
    if (!items.length) return;
    gsap.to(items, {
      opacity:  0,
      y:        direction === 'forward' ? -24 : 24,
      duration: 0.38,
      ease:     'power2.in',
      stagger:  0.05
    });
  }

  // ── Scatter layout (mobile): all images, smaller, same ellipse system ────────
  function layoutScatterMobile(scatterEl) {
    var imgs = scatterEl.querySelectorAll('.hs-scatter__img');
    var n    = imgs.length;
    if (!n) return;

    // Scale image size down relative to count, same formula as desktop but smaller
    var size  = Math.round(Math.max(88, 132 - (n - 5) * 11));
    var rX    = 32;   // horizontal ellipse radius (% of panel width)
    var rY    = 28;   // vertical   ellipse radius (% of panel height)
    var start = -130;
    var rots  = [-8, 7, -4, 9, -3, 6, -5, 8, -6, 5];

    Array.prototype.forEach.call(imgs, function (el, i) {
      var deg = start + i * (360 / n);
      var rad = deg * Math.PI / 180;
      var cx  = (50 + rX * Math.cos(rad)).toFixed(1);
      var cy  = (50 + rY * Math.sin(rad)).toFixed(1);
      var rot = rots[i % rots.length];

      el.style.left      = cx + '%';
      el.style.top       = cy + '%';
      el.style.width     = size + 'px';
      el.style.transform = 'translate(-50%, -50%) rotate(' + rot + 'deg)';
      el.style.display   = '';
    });
  }

  // ── Scatter layout (desktop): place images evenly on an ellipse around the centre ──
  function layoutScatter(scatterEl) {
    var imgs = scatterEl.querySelectorAll('.hs-scatter__img');
    var n    = imgs.length;
    if (!n) return;

    // Image width: 250 px for 5 images, shrinks ~18 px per extra image (min 160 px)
    var size  = Math.round(Math.max(160, 250 - (n - 5) * 18));
    var rX    = 37;    // horizontal ellipse radius (% of panel width)
    var rY    = 29;    // vertical ellipse radius (% of panel height)
    var start = -130;  // start angle in degrees — first image lands upper-left
    // Gentle alternating rotations; wraps for any count
    var rots  = [-8, 7, -4, 9, -3, 6, -5, 8, -6, 5];

    Array.prototype.forEach.call(imgs, function (el, i) {
      var deg = start + i * (360 / n);
      var rad = deg * Math.PI / 180;
      var cx  = (50 + rX * Math.cos(rad)).toFixed(1); // % from left (centre of image)
      var cy  = (50 + rY * Math.sin(rad)).toFixed(1); // % from top  (centre of image)
      var rot = rots[i % rots.length];

      el.style.left      = cx + '%';
      el.style.top       = cy + '%';
      el.style.width     = size + 'px';
      // translate(-50%,-50%) centres the image on the computed point before rotating
      el.style.transform = 'translate(-50%, -50%) rotate(' + rot + 'deg)';
    });
  }

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  // ── Mobile: IntersectionObserver reveal for stacked panels ───────────────────
  function initMobileReveal(outerEl) {
    if (!isMobile()) return;

    // Position scatter images using the same ellipse system, adapted for mobile
    Array.prototype.forEach.call(outerEl.querySelectorAll('.hs-scatter'), function (s) {
      layoutScatterMobile(s);
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var panels = outerEl.querySelectorAll('[data-hscroll-panel]');
    if (!panels.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var items = entry.target.querySelectorAll(CONTENT_SEL_MOBILE);
        Array.prototype.forEach.call(items, function (item, i) {
          item.style.transitionDelay = (i * 0.09) + 's';
          item.classList.add('hs-m-in');
        });
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    Array.prototype.forEach.call(panels, function (panel) {
      var items = panel.querySelectorAll(CONTENT_SEL_MOBILE);
      Array.prototype.forEach.call(items, function (item) {
        item.classList.add('hs-m-hidden');
      });
      observer.observe(panel);
    });

    // Re-layout scatter on orientation change / resize
    var mobileResizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(mobileResizeTimer);
      mobileResizeTimer = setTimeout(function () {
        if (!isMobile()) return;
        Array.prototype.forEach.call(outerEl.querySelectorAll('.hs-scatter'), function (s) {
          layoutScatterMobile(s);
        });
      }, 200);
    });
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (document.querySelector('script[src="' + src + '"]')) {
        resolve();
        return;
      }
      var s     = document.createElement('script');
      s.src     = src;
      s.onload  = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function initHScroll(outerEl) {
    if (isMobile()) return;

    var track  = outerEl.querySelector('[data-hscroll-track]');
    var panels = outerEl.querySelectorAll('[data-hscroll-panel]');
    var dots   = outerEl.querySelectorAll('[data-hscroll-dot]');

    if (!track || panels.length < 2) return;

    var panelCount = panels.length;
    var travelX    = -(panelCount - 1) * window.innerWidth;
    var scrollMult = parseInt(outerEl.dataset.hscrollSpeed, 10) || 200;
    var holdVh     = parseInt(outerEl.dataset.hscrollHold,  10) || 80;

    gsap.registerPlugin(ScrollTrigger);

    // Layout scatter images evenly around the centre text
    Array.prototype.forEach.call(outerEl.querySelectorAll('.hs-scatter'), function (s) {
      layoutScatter(s);
    });

    // Re-layout on window resize (debounced 200 ms)
    var scatterResizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(scatterResizeTimer);
      scatterResizeTimer = setTimeout(function () {
        Array.prototype.forEach.call(outerEl.querySelectorAll('.hs-scatter'), function (s) {
          layoutScatter(s);
        });
      }, 200);
    });

    // Build a timeline: pause → slide → pause
    // Duration units map 1:1 to vh of scroll distance
    var moveDur = (panelCount - 1) * scrollMult;
    var tl      = gsap.timeline();
    if (holdVh > 0) tl.to({}, { duration: holdVh });          // linger at start
    tl.to(track, { x: travelX, ease: 'none', duration: moveDur }); // horizontal slide
    if (holdVh > 0) tl.to({}, { duration: holdVh });          // linger at end

    var totalDur = tl.duration(); // holdVh + moveDur + holdVh

    /* Hide all panel content upfront — image+text panels are excluded and stay visible */
    Array.prototype.forEach.call(panels, function (panel) {
      if (panel.querySelector('.hs-iwt')) return; // leave image+text panels alone
      var items = panel.querySelectorAll(CONTENT_SEL);
      gsap.set(items, { opacity: 0, y: 36 });
    });

    var st = ScrollTrigger.create({
      trigger:      outerEl,
      animation:    tl,
      start:        'top top',
      end:          '+=' + totalDur + 'vh',
      pin:          true,
      scrub:        1.5,
      anticipatePin: 1,
      onUpdate: function (self) {
        // Map raw progress → movement-phase progress (excluding hold zones)
        var holdFrac = holdVh / totalDur;
        var p        = self.progress;
        var moveP;
        if (p <= holdFrac)           moveP = 0;
        else if (p >= 1 - holdFrac)  moveP = 1;
        else                         moveP = (p - holdFrac) / (1 - 2 * holdFrac);
        var idx = Math.round(moveP * (panelCount - 1));

        /* Update dots */
        dots.forEach(function (d, i) {
          d.classList.toggle('hs-dot--active', i === idx);
        });

        /* Animate panel content when active panel changes */
        if (idx !== lastPanelIdx) {
          var direction = idx > lastPanelIdx ? 'forward' : 'back';
          if (lastPanelIdx >= 0 && lastPanelIdx < panels.length) {
            hidePanelContent(panels[lastPanelIdx], direction);
          }
          revealPanelContent(panels[idx], direction);
          lastPanelIdx = idx;
        }
      },
      onEnter: function () {
        /* Reveal first panel content when section first enters view */
        if (lastPanelIdx === -1) {
          lastPanelIdx = 0;
          revealPanelContent(panels[0], 'forward');
        }
      }
    });

    // Dot click → scroll to that panel's position (accounting for hold offset)
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx       = parseInt(dot.dataset.hscrollDot, 10);
        var holdFrac  = holdVh / totalDur;
        var moveFrac  = 1 - 2 * holdFrac;
        var panelFrac = holdFrac + (idx / (panelCount - 1)) * moveFrac;
        var targetY   = st.start + panelFrac * (st.end - st.start);
        window.scrollTo({ top: targetY, behavior: 'smooth' });
      });
    });
  }

  /* ── Cinematic panel reveals (hs-cine) ── */
  function wireCine() {
    var bands = document.querySelectorAll('[data-hs-cine]');
    if (!bands.length) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    Array.prototype.forEach.call(bands, function (b) {
      if (b.classList.contains('hs-cine--js')) return;
      /* synchronously reveal if already on screen so the CSS safety-net
         handoff never flashes blank */
      var r = b.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0 && r.left < window.innerWidth && r.right > 0) {
        b.classList.add('hs-cine--in');
      }
      b.classList.add('hs-cine--js');
    });
    if (!('IntersectionObserver' in window) || reduced) {
      Array.prototype.forEach.call(bands, function (b) { b.classList.add('hs-cine--in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('hs-cine--in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.25 });
    Array.prototype.forEach.call(bands, function (b) {
      if (!b.classList.contains('hs-cine--in')) io.observe(b);
    });
  }

  function init() {
    var sections = document.querySelectorAll('[data-hscroll]');
    if (!sections.length) return;

    wireCine();

    if (isMobile()) {
      sections.forEach(function (el) { initMobileReveal(el); });
      return;
    }

    loadScript(GSAP_CDN)
      .then(function () { return loadScript(ST_CDN); })
      .then(function () {
        sections.forEach(function (el) { initHScroll(el); });
      })
      .catch(function (e) { console.warn('HScroll: GSAP load failed', e); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor live reload
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-hscroll]');
    if (!el) return;

    wireCine();

    if (isMobile()) {
      initMobileReveal(el);
      return;
    }

    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.getAll().forEach(function (st) {
        if (st.trigger === el) st.kill();
      });
    }
    loadScript(GSAP_CDN)
      .then(function () { return loadScript(ST_CDN); })
      .then(function () { initHScroll(el); })
      .catch(function () {});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text-excel"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── CSV parser — handles quoted fields and escaped quotes ── */
  function parseCSV(text) {
    var rows = [];
    var lines = text.split(/\r?\n/);
    for (var li = 0; li < lines.length; li++) {
      var line = lines[li];
      if (!line.trim()) continue;
      var cells = [];
      var cell = '';
      var inQ = false;
      for (var ci = 0; ci < line.length; ci++) {
        var ch = line[ci];
        if (ch === '"') {
          /* escaped quote inside quoted field */
          if (inQ && line[ci + 1] === '"') { cell += '"'; ci++; }
          else { inQ = !inQ; }
        } else if (ch === ',' && !inQ) {
          cells.push(cell.trim());
          cell = '';
        } else {
          cell += ch;
        }
      }
      cells.push(cell.trim());
      rows.push(cells);
    }
    return rows;
  }

  /* ── HTML-escape to prevent XSS ── */
  function esc(str) {
    return (str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── Detect numeric-ish cells (digits, commas, dots, %, +/-) ── */
  function isNum(str) {
    var s = (str || '').trim();
    return s !== '' && /^[+\-]?[\d,\s]+\.?\d*\s*[%]?$/.test(s);
  }

  /* ── Build and inject the <table> HTML ── */
  function renderTable(wrap, rows, maxRows, hasHeader) {
    if (!rows.length) {
      wrap.innerHTML = '<p class="rtx__no-data">No data found in the spreadsheet.</p>';
      return;
    }

    var headerRow = hasHeader ? rows[0] : null;
    var bodyRows  = hasHeader ? rows.slice(1, maxRows + 1) : rows.slice(0, maxRows);

    var html = '<div class="rtx__scroll"><table class="rtx__table">';

    if (headerRow) {
      html += '<thead><tr>';
      headerRow.forEach(function (h) {
        var cls = isNum(h) ? ' class="rtx__cell-num"' : '';
        html += '<th' + cls + '>' + esc(h) + '</th>';
      });
      html += '</tr></thead>';
    }

    html += '<tbody>';
    bodyRows.forEach(function (row, ri) {
      var rowCls = ri % 2 === 0 ? 'rtx__row-even' : 'rtx__row-odd';
      html += '<tr class="' + rowCls + '">';
      row.forEach(function (cell) {
        var cls = isNum(cell) ? ' class="rtx__cell-num"' : '';
        html += '<td' + cls + '>' + esc(cell) + '</td>';
      });
      html += '</tr>';
    });

    html += '</tbody></table></div>';
    wrap.innerHTML = html;
  }

  /* ── Fetch, parse and render one section ── */
  function load(outer) {
    var url       = outer.dataset.csvUrl;
    var maxRows   = parseInt(outer.dataset.maxRows, 10) || 20;
    var hasHeader = outer.dataset.hasHeader !== 'false';
    var wrap      = outer.querySelector('.rtx__table-wrap');
    var ts        = outer.querySelector('.rtx__timestamp');

    if (!url || !wrap) return;

    /* Cache-bust so repeat calls always get fresh data */
    var fetchUrl = url + (url.indexOf('?') !== -1 ? '&' : '?') + '_rtx=' + Date.now();

    fetch(fetchUrl)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (csv) {
        renderTable(wrap, parseCSV(csv), maxRows, hasHeader);
        if (ts) {
          var d = new Date();
          ts.textContent = 'Last updated ' +
            d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        }
      })
      .catch(function (err) {
        wrap.innerHTML =
          '<p class="rtx__no-data">' +
          'Could not load data — make sure the sheet is published as CSV and the URL is correct.' +
          '</p>';
        console.warn('[Rich Text + Spreadsheet]', err);
      });
  }

  /* ── Bootstrap all RTX sections on the page ── */
  function init() {
    document.querySelectorAll('[data-rtx-section]').forEach(function (outer) {
      var refreshMs = parseInt(outer.dataset.refresh, 10) || 0;
      load(outer);
      if (refreshMs > 0) {
        setInterval(function () { load(outer); }, refreshMs);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sawyer-areas"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var bands = document.querySelectorAll('.swar');
    if (!bands.length) return;
    if (!('IntersectionObserver' in window)) { bands.forEach(function (b) { b.classList.add('swar--in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('swar--in'); io.unobserve(e.target); } });
    }, { threshold: 0.2 });
    bands.forEach(function (b) { io.observe(b); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sawyer-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initReveal() {
    var bands = document.querySelectorAll('.swh');
    if (!bands.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    bands.forEach(function (b) { var r = b.getBoundingClientRect(); if (r.top < vh && r.bottom > 0) b.classList.add('swh--in'); });
    if (reduced || !('IntersectionObserver' in window)) { bands.forEach(function (b) { b.classList.add('swh--in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('swh--in'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    bands.forEach(function (b) { if (!b.classList.contains('swh--in')) io.observe(b); });
  }
  function initForm() {
    var forms = document.querySelectorAll('form[data-sawyer-lead]');
    forms.forEach(function (f) {
      if (f.__sawyerBound) return;
      f.__sawyerBound = true;
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        if (f.__sending) return;
        var action = f.getAttribute('action') || '';
        var fallbackEmail = f.getAttribute('data-fallback-email') || '';
        var btn = f.querySelector('button[type="submit"]');
        var thanks = f.querySelector('.swh__form-thanks');
        var err = f.querySelector('.swh__form-error');
        var origLabel = btn ? btn.textContent : 'Send enquiry';

        var data = new FormData(f);
        var payload = {};
        data.forEach(function (v, k) { payload[k] = v; });
        payload.source = payload.source || 'hero';
        payload.referrer = location.href;
        payload.submitted_at = new Date().toISOString();

        if (!(payload.name || payload.phone)) {
          if (err) { err.textContent = 'Please add your name and number so we can reply.'; err.hidden = false; }
          return;
        }

        f.__sending = true;
        if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
        if (thanks) thanks.hidden = true;
        if (err) err.hidden = true;

        var jobs = [];
        // (1) Make/n8n webhook — fires when a webhook URL is set in the section settings
        if (action) {
          jobs.push(fetch(action, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), keepalive: true }).catch(function () {}));
        }
        // (2) Shopify contact form — always emails the lead to the store inbox (works with no external tools)
        if (fallbackEmail) {
          var fd = new URLSearchParams();
          fd.append('form_type', 'contact'); fd.append('utf8', '✓');
          fd.append('contact[name]', payload.name || 'Website enquiry');
          fd.append('contact[email]', fallbackEmail);
          fd.append('contact[phone]', payload.phone || '');
          fd.append('contact[body]', 'NEW WEBSITE LEAD (hero form) — name: ' + (payload.name || '(not given)') + ' | phone: ' + (payload.phone || '(not given)') + ' | town: ' + (payload.town || '-') + ' | project: ' + (payload.message || '-'));
          jobs.push(fetch('/contact', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: fd.toString(), keepalive: true }).catch(function () {}));
        }
        // (3) Instant phone push via ntfy.sh — free, no account, lands as a notification on the owner's phone
        var ntfy = f.getAttribute('data-ntfy') || '';
        if (ntfy) {
          jobs.push(fetch('https://ntfy.sh', { method: 'POST', keepalive: true, body: JSON.stringify({
            topic: ntfy,
            title: 'New website lead — ' + (payload.name || 'enquiry'),
            message: (payload.name || '(no name)') + ' · ' + (payload.phone || 'no phone given') + '\nTown: ' + (payload.town || '-') + '\n' + (payload.message || ''),
            tags: ['seedling'], priority: 5,
            click: payload.phone ? ('tel:' + payload.phone) : ''
          }) }).catch(function () {}));
        }

        Promise.all(jobs).then(function () {
          if (thanks) thanks.hidden = false;
          f.reset();
          f.__sending = false;
          if (btn) { btn.disabled = false; btn.textContent = origLabel; }
          if (window.dataLayer) { window.dataLayer.push({ event: 'generate_lead', form: 'hero' }); }
        });
      });
    });
  }
  function init() { initReveal(); initForm(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sawyer-questions"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var bands = document.querySelectorAll('.swq');
    if (!bands.length) return;
    if (!('IntersectionObserver' in window)) { bands.forEach(function (b) { b.classList.add('swq--in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('swq--in'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    bands.forEach(function (b) { io.observe(b); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sawyer-quote-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var bands = document.querySelectorAll('.swqc');
    if (!bands.length) return;
    if (!('IntersectionObserver' in window)) { bands.forEach(function (b) { b.classList.add('swqc--in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('swqc--in'); io.unobserve(e.target); } });
    }, { threshold: 0.2 });
    bands.forEach(function (b) { io.observe(b); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sawyer-services-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init() {
    var bands = document.querySelectorAll('.swsg');
    if (!bands.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      bands.forEach(function (b) { b.classList.add('swsg--in'); }); return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('swsg--in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    bands.forEach(function (b) { io.observe(b); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sawyer-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init() {
    var bands = document.querySelectorAll('.swte');
    if (!bands.length) return;
    if (reduced || !('IntersectionObserver' in window)) { bands.forEach(function (b) { b.classList.add('swte--in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('swte--in'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    bands.forEach(function (b) { io.observe(b); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sawyer-trust-band"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function count(el) {
    var target = parseInt(el.getAttribute('data-swtb-count'), 10);
    if (isNaN(target) || reduced) { el.textContent = el.getAttribute('data-swtb-count') || el.textContent; return; }
    if (el.dataset.swtbCounted) return; el.dataset.swtbCounted = '1';
    // The REAL number is now in the HTML so crawlers and AI answer engines read it.
    // Sawyer's live site was shipping "0 Years serving families" because the markup
    // hardcoded 0 and only JS filled it in. Reset to 0 here, at animation time, so
    // the visual count-up survives without ever lying to a bot.
    el.textContent = '0';
    var dur = 1200, t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * e);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function init() {
    var bands = document.querySelectorAll('.swtb');
    if (!bands.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      bands.forEach(function (b) {
        b.classList.add('swtb--in');
        b.querySelectorAll('[data-swtb-count]').forEach(count);
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('swtb--in');
        entry.target.querySelectorAll('[data-swtb-count]').forEach(count);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.35 });
    bands.forEach(function (b) { io.observe(b); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Easing: easeOutExpo for a satisfying deceleration ── */
  function easeOutExpo(t) {
    return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
  }

  /* ── Animate one counter ── */
  function animateCounter(el) {
    if (el._counterDone) return;
    el._counterDone = true;

    var target   = parseFloat(el.dataset.counterTarget.replace(/,/g, '')) || 0;
    var decimals = parseInt(el.dataset.counterDecimals, 10) || 0;
    var duration = parseInt(el.dataset.counterDuration, 10) || 1800;
    var start    = null;

    function step(ts) {
      if (!start) start = ts;
      var elapsed  = ts - start;
      var progress = Math.min(elapsed / duration, 1);
      var eased    = easeOutExpo(progress);
      var current  = target * eased;

      el.textContent = decimals > 0
        ? current.toFixed(decimals)
        : Math.round(current).toLocaleString();

      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  /* ── Watch counters with IntersectionObserver ── */
  function init(root) {
    root = root || document;
    var counters = root.querySelectorAll('[data-counter]');
    if (!counters.length) return;

    if (!window.IntersectionObserver) {
      /* Fallback: set final value immediately */
      counters.forEach(function (el) {
        el.textContent = el.dataset.counterTarget;
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    counters.forEach(function (el) {
      /* Show zero while waiting */
      var decimals = parseInt(el.dataset.counterDecimals, 10) || 0;
      el.textContent = decimals > 0 ? (0).toFixed(decimals) : '0';
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
